export default __webpack_public_path__ + "static/media/b15.df4d7165.jpg";